import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { DataService } from "../../services/data.service";
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'app-send-feeback',
  templateUrl: './send-feeback.component.html',
  styleUrls: ['./send-feeback.component.scss']
})
export class SendFeebackComponent implements OnInit {
  loading = false;
  feedbackForm = {};
  feedBlank = '';
  feedbackAlert = false;

  constructor(
    private apiService: ApiService,
    private frontEndService: FrontEndService,
    private dataService: DataService,
    private stateService: StateService
  ) { }

  ngOnInit() {
  }

  feedbackSend() {

    if (this.feedbackForm['comments'] == "" || this.feedbackForm['comments'] == null) {
      // this.logService.printLog('error');
      this.feedBlank = "Feedback message can not be empty.";
      this.frontEndService.openModal ('heading','message');
    } else {
      // this.logService.printLog('Success');
      this.feedbackForm['user_id'] = this.dataService.userDetails['user_id'];
      this.loading = true;
      this.apiService.feedBackReport(this.feedbackForm, (response) => {
        this.loading = false;
        if (response.status == true) {
          this.frontEndService.addToast('Success', response['message'], 'success');
          this.feedbackAlert = true;
          this.feedbackForm['comments'] = "";
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/send-feeback/send-feeback.component.ts